import { HttpInterceptorFn } from '@angular/common/http';
import {environment} from "../environments/environment";

export const xdebugInterceptor: HttpInterceptorFn = (req, next) => {
  if(!environment.useXDebugInterceptor) return next(req);
  const cloned = req.clone({
    setParams : {
      "XDEBUG_SESSION_START" : "1"
    }
  })
  return next(cloned);
};
